import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import DeletedNotice from './DeletedNotice';
import ActiveRow from '../ActiveRow';
import Dialog from 'rc-dialog';
import Table from 'rc-table';
import Icon from 'react-fa';
import 'rc-table/assets/index.css';
import { GenericAlert } from 'com-gyf-webcore-userinterfacecomponents';

const Alerta = (props) => {
    if (props.mostrarError == true) {
        return <GenericAlert message="La operación fue realizada correctamente." type="success" />;
    } else {
        return null;
    }
}

const linkStyle = {
    color: 'white',
    textDecoration: 'none'
};

class Tarjetas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deleteDialogVisible: false,
            showDeletedNotice: false
        };

        this.props.mostrarAlertaProcesoFinalizado(false);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.data.procesoExitoso == true)
            this.setState({ deleteDialogVisible: false });
    }

    openDeleteDialog() {
        this.setState({ deleteDialogVisible: true });
    }

    changeTipoBorrado(tipo) {
        this.setState({ tipoBorrado: tipo });
    }

    closeDeleteDialog() {
        this.setState({ deleteDialogVisible: false });
    }

    deleteCard() {
        this.setState({ showDeletedNotice: true, deleteDialogVisible: false });
    }

    render() {

        const columns = [
            {
                title: 'N°',
                dataIndex: 'key',
                key: 'key'
            },
            {
                title: 'NOMBRE',
                dataIndex: 'nombre',
                key: 'nombre'
            },
            {
                title: '',
                dataIndex: 'numero',
                key: 'numero'
            },
            {
                title: 'LÍMITE',
                dataIndex: 'limite',
                key: 'limite'
            },
            {
                title: 'VENC.',
                dataIndex: 'vencimiento',
                key: 'vencimiento'
            },
            {
                title: ' ',
                dataIndex: 'estado',
                key: 'estado',
                render: (text, record) => {
                    return <ActiveRow newCard={false} estado={record.estado} isChildRow={true} />;
                }
            },
            {
                title: ' ',
                dataIndex: 'borrar',
                key: 'borrar',
                render: (index, record) => record.estado == 0 /*Baja*/ ? null :
                    <div onClick={() => this.openDeleteDialog()}><i className="glyphicon glyphicon-trash hand-pointer" /></div>
            }
        ];

        const { cuenta, cuentaTitular } = this.props;
        const data = cuenta.children;
        const tarjetaActual = cuentaTitular.tarjeta;

        let plasticos = this.props.plasticos;
        let tarjetaSeleccionada = this.props.plasticos.tarjetas.find(x => x.Numero == this.props.tarjetaActual.numero);

        let arrayResult = []
        for (var i = 0; i < plasticos.cuentasDelivery.length; i++) {
            if (tarjetaSeleccionada.NumeroCuenta == plasticos.cuentasDelivery[i].CodigoCuenta) {
                for (var j = 0; j < plasticos.tarjetas.length; j++) {
                    if (plasticos.cuentasDelivery[i].CodigoCuenta == plasticos.tarjetas[j].NumeroCuenta) {
                        arrayResult.push({
                            nombre: plasticos.tarjetas[j].Nombre,
                            childRow: true,
                            limite: plasticos.tarjetas[j].LimiteDescripcion,
                            numero: plasticos.tarjetas[j].Numero,
                            vencimiento: convertDate(plasticos.tarjetas[j].FechaVigenciaHasta),
                            estado: plasticos.tarjetas[j].Activo,
                            key: plasticos.tarjetas[j].idCuentaPlastico
                        });
                    }
                }
            }
        }

        let tarjeta = this.props.plasticos.tarjetas.find(x => x.Numero == this.props.tarjetaActual.numero);
        let solicitudes = this.props.plasticos.solicitudes;

        let soloLectur = false;
        for (var i = 0; i < solicitudes.length; i++) {
            if (solicitudes[i].NumeroCuenta == tarjeta.NumeroCuenta && (solicitudes[i].TdTransaccionLinkId == 210001 || solicitudes[i].TdTransaccionLinkId == 210002))
                soloLectur = true;

        }

        let nroCuenta = this.props.tarjetaActual !== undefined ? this.props.tarjetaActual.cuentaNro : "";

        return (
            <div>

                <div className="DetalleHeading table-detalle-apoderado">
                    <span>{cuenta.cuentas} {cuenta.numero}</span>
                    <i className="glyphicon glyphicon-menu-right"></i>
                    <span>{tarjetaActual}</span>
                    <i className="glyphicon glyphicon-menu-right"></i>
                    <span>Tarjetas</span>
                    <span className="IconContainerTarjetas">
                        <span className="Icon-File">
                            <Icon name="print" size="lg" />
                        </span>
                        <span className="Icon-PDF">
                            <Icon name="file-pdf-o" size="lg" />
                        </span>
                    </span>
                    <hr />
                </div>

                <DeletedNotice show={this.state.showDeletedNotice} />

                <Alerta mostrarError={this.props.data.procesoExitoso} />
                {soloLectur ? null :
                    <Link className="color-white" to={"/tarjetas/Plasticos/DELIVERY/NuevaSolicitud/" + nroCuenta} > <button className="btn btn-cta btn-nueva-cuenta">Nueva tarjeta</button></Link>

                }


                <br />

                <Table
                    columns={columns}
                    data={arrayResult}
                    emptyText="No existen tarjetas para mostrar."
                    className="table-detalle-apoderado"
                />


                <div>
                    <Dialog
                        visible={this.state.deleteDialogVisible}
                        onClose={this.closeDeleteDialog.bind(this)}
                        animation="slide-fade"
                        maskAnimation="fade"
                        style={{ width: 600 }}
                        title="Baja de tarjeta para titular"
                        footer={
                            [
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    key="cancel"
                                    onClick={() => this.props.borrarTarjeta(this.props.plasticos, this.props.tarjetaActual, this.state.tipoBorrado, this.props.tarjetaActual.cuentaNro)}
                                >
                                    Aceptar
                        </button>,
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    key="delete"
                                    onClick={this.closeDeleteDialog.bind(this)}
                                >
                                    Cancelar
                        </button>
                            ]
                        }
                    >

                        <form action="">
                            <input type="radio" name="baja" value="titular" className="RadioInput" onClick={() => this.changeTipoBorrado("UNICO")} /> &nbsp; Dar de baja únicamente la tarjeta del titular y solicitar una nueva tarjeta.<br />
                            <input type="radio" name="baja" value="adicionales" className="RadioInput" onClick={() => this.changeTipoBorrado("MULTIPLE")} /> &nbsp;  Dar de baja la tarjeta del titular y sus adicionales.<br />
                        </form>

                        <br />

                    </Dialog>
                </div>


            </div>
        );
    }


}

function convertDate(inputFormat) {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat);
    return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
}

export default Tarjetas;
